var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "payment-cadence-modal" } },
    [
      _c(
        "Modal",
        {
          attrs: {
            modalId: "change-payment-cadence-modal",
            size: "modal-lg modal-size"
          },
          on: {
            hidden: function($event) {
              return _vm.closeChangeCadenceModal()
            }
          }
        },
        [
          this.loadingData
            ? _c(
                "div",
                [
                  _c(
                    "b-row",
                    { staticClass: "text-center pt-5 pb-5" },
                    [
                      _c(
                        "b-col",
                        [
                          _c("b-spinner", {
                            staticStyle: { width: "10rem", height: "10rem" },
                            attrs: { variant: "warning", label: "Spinning" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "div",
                [
                  _c(
                    "ModalHeader",
                    {
                      style: { padding: "4px 12px" },
                      attrs: {
                        title: _vm.$t("xManagePlan"),
                        icon: "far fa-circle-dollar colorOrange mr-1"
                      }
                    },
                    [
                      _c("div", { staticClass: "cols-auto" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-icon-button btn-icon-button--gray",
                            attrs: {
                              type: "button",
                              "data-test-hook": "CloseModalBtn"
                            },
                            on: {
                              click: function($event) {
                                return _vm.closeChangeCadenceModal()
                              }
                            }
                          },
                          [_c("i", { staticClass: "fas fa-times" })]
                        )
                      ])
                    ]
                  ),
                  _vm.paying
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-row",
                            { staticClass: "text-center" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c("b-spinner", {
                                    staticStyle: {
                                      width: "10rem",
                                      height: "10rem"
                                    },
                                    attrs: {
                                      variant: "warning",
                                      label: "Spinning"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c("ModalBody", [
                            _c("div", { staticClass: "row mb-3" }, [
                              _c("div", { staticClass: "col" }, [
                                _c(
                                  "div",
                                  {
                                    attrs: {
                                      "data-test-hook": "YouSaveMoneyText"
                                    }
                                  },
                                  [
                                    this.yearly
                                      ? _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("xSaveMoneyYearlyText", {
                                                  0: this.currentSubPrice
                                                })
                                              ) +
                                              " "
                                          )
                                        ])
                                      : this.monthly
                                      ? _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "xSaveMoneyMonthlyText",
                                                  { 0: this.getNewPlanPrice() }
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              ])
                            ]),
                            _c("div", { staticClass: "row mb-3" }, [
                              _c("div", { staticClass: "col" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "text",
                                    attrs: {
                                      "data-test-hook": "RenewalDetails"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("xRenewalDetails")) +
                                        " "
                                    ),
                                    _c("ul", [
                                      _c("li", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "xCurrentPlanDetailsText",
                                                {
                                                  0: _vm
                                                    .$moment(this.purchasedDate)
                                                    .format("MM/DD/YYYY"),
                                                  1: _vm
                                                    .$moment(_vm.endDate)
                                                    .format("MM/DD/YYYY")
                                                }
                                              )
                                            ) +
                                            " "
                                        )
                                      ]),
                                      this.yearly
                                        ? _c("li", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "xNewMonthlyPaymentText",
                                                    {
                                                      0: this.getNewPlanPrice(),
                                                      1: _vm
                                                        .$moment(_vm.endDate)
                                                        .format("MM/DD/YYYY")
                                                    }
                                                  )
                                                ) +
                                                " "
                                            )
                                          ])
                                        : this.monthly
                                        ? _c("li", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "xNewYearlyPaymentText",
                                                    {
                                                      0: this.getNewPlanPrice(),
                                                      1: _vm
                                                        .$moment(_vm.endDate)
                                                        .format("MM/DD/YYYY")
                                                    }
                                                  )
                                                ) +
                                                " "
                                            )
                                          ])
                                        : _vm._e()
                                    ])
                                  ]
                                )
                              ])
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "row",
                                attrs: {
                                  "data-test-hook":
                                    "AreYouSureYouWantToSwitchText"
                                }
                              },
                              [
                                this.yearly
                                  ? _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("xAreYouSureMonthlyText")
                                          ) +
                                          " "
                                      )
                                    ])
                                  : this.monthly
                                  ? _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("xAreYouSureYearlyText")
                                          ) +
                                          " "
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ]),
                          _c(
                            "ModalFooter",
                            {
                              staticClass:
                                "d-flex justify-content-center pr-0 pl-0"
                            },
                            [
                              this.yearly
                                ? _c("div", { staticClass: "modal-buttons" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-outline-warning",
                                        attrs: {
                                          type: "button",
                                          title: _vm.$t("xKeepYearlyBtn"),
                                          "data-test-hook": "KeepCadenceBtn",
                                          disabled: this.paying
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.closeChangeCadenceModal()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("xKeepYearlyBtn")) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-warning ml-2",
                                        attrs: {
                                          type: "button",
                                          title: _vm.$t("xSwitchMonthlyBtn"),
                                          "data-test-hook": "SwitchCadenceBtn",
                                          disabled: this.paying
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.changePaymentCadence()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("xSwitchMonthlyBtn")
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ])
                                : this.monthly
                                ? _c("div", { staticClass: "modal-buttons" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-outline-warning",
                                        attrs: {
                                          type: "button",
                                          title: _vm.$t("xKeepMonthlyBtn"),
                                          "data-test-hook": "KeepCadenceBtn",
                                          disabled: this.paying
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.closeChangeCadenceModal()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("xKeepMonthlyBtn")) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-warning ml-2",
                                        attrs: {
                                          type: "button",
                                          title: _vm.$t("xSwitchYearlyBtn"),
                                          "data-test-hook": "SwitchCadenceBtn",
                                          disabled: this.paying
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.changePaymentCadence()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("xSwitchYearlyBtn")) +
                                            " "
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                ],
                1
              )
        ]
      ),
      _c("PaymentModal", {
        attrs: {
          "modal-id": "change-cadence-payment",
          "selected-product": _vm.selectedProduct,
          "account-profile": _vm.accountProfile
        },
        on: {
          submit: _vm.subscribeToNewProduct,
          goBack: _vm.returnToManagePlanModal,
          savePremiumFeaturesGettingReadyInfo: _vm.handleCadenceChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }